import { useQuery } from '@tanstack/react-query';

import * as LoyaltyService from '~/services/LoyaltyService';

import { pointsPurchaseQueryKeys } from './pointsPurchaseQueryKeys';

export function useGetPointsPurchaseOffers(currency?: string) {
  return useQuery({
    queryKey: pointsPurchaseQueryKeys.offersByCurrency(currency ?? 'all'),
    queryFn: async ({ signal }) => LoyaltyService.listPointsPurchaseOffersAdmin({ currency }, { signal }),
  });
}
